<template>
  <div class="modalAdd">
    <b-modal id="modalFileEdit" ref="modalFileEdit" centered size="lg" modal-class="modal-no-border modal-radius modal-rename top-mb" no-close-on-backdrop>
      <template v-slot:modal-header="{ close }">
        <!-- Emulate built in modal header close button action -->
        <div class="title-modal text-center w-100 ">
          <h2 class="title">ファイル編集</h2>
          <div class="btn-closeModal" @click="closeModalEdit">
            <svg height="329pt" viewBox="0 0 329.26933 329" width="329pt" xmlns="http://www.w3.org/2000/svg"><path d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"/></svg>
          </div>
        </div>
      </template>
      <div class="modalUser--main" :class="{'chrome': checkChrome, 'firefox': checkFirefox }">
        <div class="form-group">
          <label for="name" class="vendor__label mt-15">ファイル名<span class="required">*</span></label>
          <div class="input-group">
            <input type="text" name="" id="name" class="input-form" placeholder="ファイル名を入力してください" v-model="detailFile.name" :class="nameFormat()">
            <small v-if="!$v.detailFile.name.required && invalid" class="text-input error">{{message.FILE_NAME_REQUIRED}}</small>
            <small v-if="$v.detailFile.name.required && invalid && !$v.detailFile.name.valid" class="text-input error">{{message.FILE_NAME_FORMAT}}</small>
            <small v-if="errorName" class="text-input error">{{errorFile(errorName[0])}}</small>
          </div>
        </div>
        <div class="form-group">
          <label for="tags" class="vendor__label mt-15">タグ</label>
          <div>
            <div>
              <multiselect id="tags"
                           ref="multiselect" class="tags-search"
                           @open="closeAutocomplete"
                           :value="detailFile.tags" tag-placeholder="選択するように押してください"
                           placeholder="タグを入力してください" label="name"
                           selectLabel="選択するように押してください"
                           @select="onSelect"
                           :options="listTags" :hide-selected="true" @remove="closeTags"
                           :multiple="true" :taggable="true" track-by="name"
                           @search-change="getTag" @tag="addTag">
                <span slot="noOptions"></span>
                <span slot="noResult">タグが既に存在しています</span>
              </multiselect>
            </div>
          </div>
        </div>
       <div class="form-group">
         <label for="aria" class="vendor__label mt-15">説明</label>
         <div class="input-group">
           <textarea rows="4" id="aria" placeholder="説明を入力してください" class="input-form textarea textarea-addFile" :class="{error: !$v.detailFile.description.maxLength && invalid}" v-model="detailFile.description"></textarea>
           <small v-if="!$v.detailFile.description.maxLength && invalid" class="text-input error">{{message.FILE_DESCRIPTION}}</small>
         </div>
       </div>

        <!-- Start: Additional Attachments -->
        <div class="form-group">
          <label class="vendor__label mt-4">添付ファイルを追加する</label>
          <div class="avatar-addFile" v-for="(file,index) in attachments" :key="`key-${file.refIndex}`">
            <div class="input-upload drag-handle justify-content-between" v-if="file.popup">
              <div class="d-flex align-items-center w-100">
                <div class="avatar1 avatar-thumbnail upload-thumbnail">
                  <img :src="file.src" alt class="avt-modal" :id="`displayAttachment-${file.refIndex}`" :ref="`displayAttachment-${file.refIndex}`" v-if="file.type == 'image'"/>
                  <img src="../../../assets/images/pdf.svg" alt class="avt-modal upload-thumb-pdf" :ref="`displayAttachment-${file.refIndex}`" v-if="file.type == 'pdf'"/>
                </div>
                <div class="description">
                  <div class="text-big d-none d-lg-block">{{file.videoName}} <span v-if="file.size"> - {{convertSize(file.size)}}</span></div>
                  <div class="text-big d-lg-none d-block">{{file.videoName}} <span v-if="file.size"> - {{convertSize(file.size)}}</span></div>
                </div>
              </div>
              <div class="close-icon">
                <img src="@img/icon/icon-close.svg" @click="changeAttachment(index)">
              </div>
            </div>
            <div class="input-upload drag-handle justify-content-between" v-else>
              <div class="d-flex align-items-center input-group avatar-upload-mb">
                <div class="avatar1 avatar-af">
                  <div class="input-upload">
                    <label :for="`uploadfile2-${file.refIndex}`" class="label-upload"></label>
                    <input type="file" :id="`uploadfile2-${file.refIndex}`" :name="`uploadfile2-${file.refIndex}`" accept="image/*,application/pdf,capture=camcorder" class="btn-file"  @change="changeAttachmentFile($event, index)"/>
                  </div>
                </div>
                <div class="description">
                  <div class="text-big">ファイル選択</div>
                  <div class="text-small">最大5MBの画像PDF最大2MB。</div>
                </div>
              </div>
              <div class="close-icon">
                <img src="@img/icon/icon-close.svg" @click="removeAttachment(index)">
              </div>
            </div>
            <div class="form-group drag-handle" >
              <div class="input-group">
                <small class="text-input error" v-if="hasError('format', file)">{{message.FILE_FORMAT}}</small>
                <small class="text-input error" v-if="hasError('size', file)">{{message.VIDEO_SIZE}}</small>
                <small class="text-input error" v-if="hasError('empty', file)">{{message.FILE_REQUIRED}}</small>
              </div>
            </div>
          </div>

          <b-button @click="addAttachments" class="mt-3">
            追加
          </b-button>
        </div>
        <!-- End: Additional Attachments -->

      </div>
      <template v-slot:modal-footer>
        <div class="w-100">
          <div class="d-flex justify-content-center btn-reverse">
            <button
              class="btn btn-rounder btn-secondary btn-contact w-100 btn-basic mr-30"
              type="button" @click="closeModalEdit">キャンセル</button>
            <button
              class="btn btn-rounder btn-primary btn-contact w-100 btn-basic"
              type="button" @click="editFile">保存</button>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { BModal, VBModal } from 'bootstrap-vue'
import { required, maxLength } from 'vuelidate/lib/validators'
import {MEDIA_TYPE} from '@/utils/constant'
import {MESSAGE} from '@/utils/errorjapanese'
import errorMessage from '@/utils/errormessage'
import Multiselect from 'vue-multiselect'
import {mapState} from 'vuex'
import _ from 'lodash'
export default {
  name: 'EditFile',
  data () {
    return {
      modalShow: false,
      message: MESSAGE,
      invalid: false,
      checkChrome: false,
      checkFirefox: false,
      attachments: []
    }
  },
  watch: {
    'detailFile.name' () {
      this.$store.commit('managerFolder/CHANGE_ERROR_NAME', '')
    },
    'detailFile.attachments' (newVal) {
      this.attachments = []
      for (var x in newVal) {
        if (newVal[x].url !== '') {
          let filename = newVal[x].url
          filename = filename.split('\\').pop().split('/').pop()

          this.attachments.push(
            {
              file: null,
              videoName: filename,
              rangeValue: [0],
              size: null,
              min: 0,
              max: 100,
              errors: {},
              popup: true,
              refIndex: (Date.now() + Math.random()),
              media_type_id: newVal[x].media_type_id,
              type: (MEDIA_TYPE.PDF_ROLE_ID === newVal[x].media_type_id) ? 'pdf' : 'image',
              src: newVal[x].url,
              isOld: true
            }
          )
        }
      }
    }
  },
  validations: {
    detailFile: {
      name: {
        required,
        valid (name) {
          return !name.includes('/')
        }
      },
      description: {
        maxLength: maxLength(1000)
      }
    }
  },
  components: {
    'b-modal': BModal,
    Multiselect
  },
  directives: {
    // Note that Vue automatically prefixes directive names with `v-`
    'b-modal': VBModal
  },
  methods: {
    nameFormat () {
      return (!this.$v.detailFile.name.required && this.invalid) || this.errorName ? 'error' : ''
    },
    onSelect (skill) {
      let data = null
      if (!_.isEmpty(this.detailFile.tags)) {
        data = this.detailFile.tags.find(n => n.name === skill)
      }
      if (_.isEmpty(this.detailFile.tags) || (!_.isEmpty(this.detailFile.tags) && !data)) {
        this.$store.commit('managerFolder/CHANGE_DETAIL_FILE_EDIT', skill)
      }
    },
    closeAutocomplete () {
      this.$refs.multiselect.$refs.search.setAttribute('autocomplete', 'off')
    },
    closeTags (index) {
      let deleteIndex = this.detailFile.tags.findIndex(n => n.name === index.name)
      this.detailFile.tags.splice(deleteIndex, 1)
    },
    addTag (skill) {
      let data = null
      const tag = {
        name: skill
      }
      if (!_.isEmpty(this.detailFile.tags)) {
        data = this.detailFile.tags.find(n => n.name === skill)
      }
      if (_.isEmpty(this.detailFile.tags) || (!_.isEmpty(this.detailFile.tags) && !data)) {
        this.$store.commit('managerFolder/CHANGE_DETAIL_FILE_EDIT', tag)
      }
    },
    getTag (value) {
      if (value) {
        setTimeout(() => {
          this.$store.dispatch('managerFolder/getTag', {name: value})
        }, 1000)
      } else {
        setTimeout(() => {
          this.$store.dispatch('managerFolder/getTag')
        }, 1000)
      }
    },
    errorFile (value) {
      return errorMessage.errorFile(value)
    },
    async editFile (e) {
      e.preventDefault()
      this.invalid = this.$v.$invalid
      if (this.invalid) {
        this.$v.$touch()
        return
      }

      this.buttonLoad = true
      const formData = new FormData()

      formData.append('id', this.detailFile.id)
      formData.append('name', this.detailFile.name)
      formData.append('description', this.detailFile.description ? this.detailFile.description : '')

      for (let i = 0; i < this.detailFile.tags.length; i++) {
        if (this.tags[i].id) {
          formData.append('tags' + '[' + i + ']' + '[name]', this.detailFile.tags[i].name)
          formData.append('tags' + '[' + i + ']' + '[id]', this.detailFile.tags[i].id)
        } else {
          formData.append('tags' + '[' + i + ']' + '[name]', this.detailFile.tags[i].name)
        }
      }

      formData.append('totalAttachments', this.attachments.length)

      if (this.attachments.length > 0) {
        for (var i in this.attachments) {
          formData.append(`attachments${i}-isOld`, this.attachments[i].isOld)

          if (!this.attachments[i].isOld) {
            formData.append(`attachments${i}`, this.attachments[i].file)
            formData.append(`attachments${i}-url`, '')
          } else {
            formData.append(`attachments${i}-url`, this.attachments[i].src)
          }

          formData.append(`attachments${i}-type`, this.attachments[i].type)
          formData.append(`attachments${i}-media_type_id`, this.attachments[i].media_type_id)
        }
      }

      await this.$store.dispatch(
        'managerFolder/updateFile',
        {
          id: this.detailFile.id,
          name: this.detailFile.name,
          tags: this.detailFile.tags,
          description: this.detailFile.description,
          modal: this.$refs['modalFileEdit'],
          formData: formData
        }
      )
    },
    closeModalEdit () {
      this.invalid = false
      this.$store.commit('managerFolder/CHANGE_DETAIL_FILE', '')
      this.$store.commit('managerFolder/CHANGE_ERROR_NAME', '')
      this.$refs['modalFileEdit'].hide()
    },
    hasError (type, file) {
      if (Object.keys(file.errors).length > 0) {
        let keys = Object.keys(file.errors)
        if (type === 'empty') {
        }
        return keys.includes(type)
      }
      return false
    },
    addAttachments () {
      this.attachments.push(
        {
          file: null,
          videoName: '',
          duration: 0,
          size: null,
          rangeValue: [0],
          min: 0,
          max: 100,
          errors: {},
          popup: false,
          refIndex: (Date.now() + Math.random()),
          media_type_id: null,
          type: '',
          src: '',
          isOld: false
        }
      )
    },
    changeAttachment (index) {
      this.attachments[index].popup = false
    },
    removeAttachment (index) {
      this.attachments.splice(index, 1)
    },
    changeAttachmentFile (e, index) {
      e.preventDefault()
      const file = e.target.files[0]
      this.attachments[index].file = e.target.files[0]
      this.attachments[index].videoName = e.target.files[0].name
      this.attachments[index].size = e.target.files[0].size

      this.attachments[index].errors = {}
      this.attachments[index].isOld = false

      if (file.name.match(/\.(jpg|jpeg|png|bmp|gif)$/i)) {
        if (this.attachments[index].size >= 5242880) {
          this.attachments[index].popup = false
          this.attachments[index].errors.size = true
          this.$forceUpdate()
          return false
        }

        let reader = new FileReader()
        this.attachments[index].popup = true
        this.attachments[index].type = 'image'

        reader.onload = e => {
          this.attachments[index].src = e.target.result
        }
        reader.readAsDataURL(file)
      } else if (file.name.match(/\.(pdf)$/i)) {
        if (this.attachments[index].size >= 2097152) {
          this.attachments[index].popup = false
          this.attachments[index].errors.size = true
          this.$forceUpdate()
          return false
        }
        this.attachments[index].popup = true
        this.attachments[index].type = 'pdf'
      } else {
        this.attachments[index].popup = false
        this.attachments[index].errors.format = true; return false
      }
    }
  },
  computed: {
    ...mapState({
      listTags: state => state.managerFolder.listTags,
      detailFile: state => state.managerFolder.detailFile,
      errorName: state => state.managerFolder.errorName
    })
  },
  mounted () {
    var device = navigator.userAgent.toLowerCase()

    // add class for chrome in macos
    if (device.indexOf('chrome') > -1) {
      this.checkChrome = true
    }
    // add class for firefox in macos
    if (device.indexOf('firefox') > -1) {
      this.checkFirefox = true
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped lang="scss">
@import "@/assets/stylesheet/vendor/detail_vendor.scss";
@import "@/assets/stylesheet/vendor/uploadfile.scss";
@import "@/assets/stylesheet/mypage/detail_mypage.scss";
.description {
  word-break: break-all;
}
</style>



// WEBPACK FOOTER //
// src/components/Manager/FolderManagerment/FileEdit.vue